import { filterOptions } from '@/utils/query-base'

// const city = filterOptions(['EQ', 'EMPTY', 'NEMPTY', 'NE'])
const all = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'BT', 'GT', 'LT', 'LE', 'GE'])
const cusname = filterOptions(['EQ', 'EMPTY', 'NE', 'NEMPTY', 'CP', 'CP-S'])

export default {
  'product_id': {
    title: '产品',
    type: 'dialog',
    equation: all,
    dialog: {
      component: 'ProductSelect',
      title: '产品'
    },
    width: 200
  },
  'description': {
    title: '产品描述',
    type: 'input',
    equation: all,
    width: 400
  },
  'degree': {
    title: '度数'
  },
  'customer': {
    title: '客户编号',
    type: 'dialog',
    equation: cusname,
    dialog: {
      component: 'ClientSelect',
      title: '客户编号'
    }
  },
  'name1': {
    title: '客户描述',
    type: 'input',
    equation: all
  },
  'planqty_box': {
    title: '数量（件）'
  },
  'planqty_bottle': {
    title: '数量（瓶）'
  },
  'planqty_ton': {
    title: '数量（吨）'
  },
  'uname': {
    title: '操作人',
    type: 'input',
    equation: all
  },
  'datum': {
    title: '导入日期',
    type: 'date',
    equation: all
  },
  'status': {
    title: '备注',
    type: 'input',
    equation: all
  }
}



// WEBPACK FOOTER //
// ./src/views/material-plan-manage/config/materialPlanImport.js